export const IMAGE_BASE_URL = `https://${process.env.REACT_APP_IMAGE_BASE_URL}`;

export const getImageUrl = (fileName) =>
    `${IMAGE_BASE_URL}/${String(fileName).replace(/^\/+/, '')}`;

export const rewriteImageUrls = (html) =>
    html.replaceAll('https://ara-images.s3.amazonaws.com', IMAGE_BASE_URL);